import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { ToastService, CloseActionTypes, ToastBySubjectTypes } from './toast-service.service';
import { ToasterComponent, ToasterOptions, ToasterIntent } from './toaster.component';

export type CustomLink = {
  action: () => void;
  label: string;
};

export type ToasterBySubjectOptions = ToasterOptions & {
  actionType?: CloseActionTypes;
  customTitleLink?: CustomLink;
  toasterType?: string;
  customSubtextLink?: CustomLink;
};

@Component({
  moduleId: module.id,
  selector: 'toaster-by-subject',
  templateUrl: './toaster-by-subject.component.html',
})
export class ToasterBySubject extends ToasterComponent implements OnInit, OnDestroy {
  toastSubjectSub: Subscription;
  actionType: CloseActionTypes;
  customTitleLink?: CustomLink;
  customSubtextLink?: CustomLink;

  constructor(private readonly toastService: ToastService) {
    super();
  }

  ngOnInit() {
    this.toastSubjectSub = this.toastService.toastSubject.subscribe(({ title, options }) => {
      if (options && options.actionType) {
        this.actionType = options.actionType;
      }

      if (options && options.customTitleLink) {
        this.customTitleLink = options.customTitleLink;
      }

      if (options && options.customSubtextLink) {
        this.customSubtextLink = options.customSubtextLink;
      }

      if (options && options.intent) {
        this.intent = options.intent;
      } else {
        this.intent = ToasterIntent.SUCCESS;
      }

      if (options && options.intentIcon) {
        this.intentIcon = options.intentIcon;
      } else {
        this.intentIcon = 'confirm-small';
      }

      if (options && options.toasterType && options.toasterType === ToastBySubjectTypes.TELE_MISSED_QUESTION) {
        this.toastService.isOpen.next(true);
      }

      this.notify(title, options);
    });
  }

  ngOnDestroy(): void {
    if (this.toastSubjectSub) {
      this.toastSubjectSub.unsubscribe();
    }
  }

  customClose() {
    super.close();
    this.toastService.isOpen.next(false);
    this.toastService.closeAction.next(CloseActionTypes.CLOSE);
  }

  performNamedAction(type: CloseActionTypes): void {
    super.close();
    this.toastService.isOpen.next(false);
    this.toastService.closeAction.next(type);
  }

  handleCustonTitleLinkAction(): void {
    super.close();
    this.toastService.isOpen.next(false);
    this.customTitleLink.action();
  }

  handleCustomSubtextLinkAction(): void {
    super.close();
    this.toastService.isOpen.next(false);
    this.customSubtextLink.action();
  }
}
